"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Vanush Voskanyan 27/4/2018
 */
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var BETWEEN_CONDITION_MESSAGE = 'reporting_designer_conditional_formatting_between_condition_message';
var EQUAL_OPERATOR_MESSAGE = 'reporting_designer_conditional_formatting_equal_operator_message';
var NOT_EQUAL_OPERATOR_MESSAGE = 'reporting_designer_conditional_formatting_not_equal_operator_message';
var GREATER_THAN_OPERATOR_MESSAGE = 'reporting_designer_conditional_formatting_greater_than_operator_message';
var GREATER_OR_EQUAL_OPERATOR_MESSAGE = 'reporting_designer_conditional_formatting_between_greater_or_equal_operator_message';
var LESS_THAN_OPERATOR_MESSAGE = 'reporting_designer_conditional_formatting_between_less_than_operator_message';
var LESS_OR_EQUAL_OPERATOR_MESSAGE = 'reporting_designer_conditional_formatting_between_less_or_equal_operator_message';
var ConditionTextGeneratorService = /** @class */ (function () {
    function ConditionTextGeneratorService(messageService, _measurePathService, _languageService) {
        this.messageService = messageService;
        this._measurePathService = _measurePathService;
        this._languageService = _languageService;
    }
    ConditionTextGeneratorService.prototype.initializeMeasurePaths = function (dataSetId) {
        this._allMeasurePaths = Observable_1.Observable.fromPromise(this._measurePathService.getAllMeasurePaths(dataSetId));
    };
    ConditionTextGeneratorService.prototype.getBetweenFormattingConditionInfo = function (condition, measurePathHolderId) {
        var _this = this;
        return this.messageService.getMessageWithPlaceholder(BETWEEN_CONDITION_MESSAGE, [condition.getValueFrom().toString(), condition.getValueTo().toString()])
            .flatMap(function (operatorText) {
            return _this.getName(measurePathHolderId).flatMap(function (nameMap) {
                return _this._languageService.getCurrentLanguage().map(function (language) {
                    var measureName = nameMap.get(language.getId());
                    return measureName + " " + operatorText;
                });
            });
        });
    };
    ConditionTextGeneratorService.prototype.getConstantFormattingConditionInfo = function (condition, measurePathHolderId) {
        var _this = this;
        return this.getBooleanOperatorInfo(condition.getBooleanOperator()).flatMap(function (operatorText) {
            return _this.getName(measurePathHolderId).flatMap(function (nameMap) {
                return _this._languageService.getCurrentLanguage().map(function (language) {
                    var measureName = nameMap.get(language.getId());
                    return measureName + " " + operatorText + " " + condition.getValue();
                });
            });
        });
    };
    ConditionTextGeneratorService.prototype.getMeasureToMeasureComparisonFormattingConditionInfo = function (condition, measure1PathHolderId, measure2PathHolderId) {
        var _this = this;
        return this.getBooleanOperatorInfo(condition.getBooleanOperator()).flatMap(function (operatorText) {
            return _this.getName(measure1PathHolderId).flatMap(function (firstNameMap) {
                return _this.getName(measure2PathHolderId).flatMap(function (secondNameMap) {
                    return _this._languageService.getCurrentLanguage().map(function (language) {
                        var firstMeasureName = firstNameMap.get(language.getId());
                        var secondMeasureName = secondNameMap.get(language.getId());
                        return firstMeasureName + " " + operatorText + " " + secondMeasureName;
                    });
                });
            });
        });
    };
    ConditionTextGeneratorService.prototype.getBooleanOperatorInfo = function (booleanOperator) {
        if (booleanOperator instanceof idm_report_export_service_client_js_1.EqualOperatorDto) {
            return this.messageService.getMessage(EQUAL_OPERATOR_MESSAGE);
        }
        else if (booleanOperator instanceof idm_report_export_service_client_js_1.NotEqualOperatorDto) {
            return this.messageService.getMessage(NOT_EQUAL_OPERATOR_MESSAGE);
        }
        else if (booleanOperator instanceof idm_report_export_service_client_js_1.GreatOperatorDto) {
            return this.messageService.getMessage(GREATER_THAN_OPERATOR_MESSAGE);
        }
        else if (booleanOperator instanceof idm_report_export_service_client_js_1.GreatOrEqualOperatorDto) {
            return this.messageService.getMessage(GREATER_OR_EQUAL_OPERATOR_MESSAGE);
        }
        else if (booleanOperator instanceof idm_report_export_service_client_js_1.LessOperatorDto) {
            return this.messageService.getMessage(LESS_THAN_OPERATOR_MESSAGE);
        }
        else if (booleanOperator instanceof idm_report_export_service_client_js_1.LessOrEqualOperatorDto) {
            return this.messageService.getMessage(LESS_OR_EQUAL_OPERATOR_MESSAGE);
        }
    };
    ConditionTextGeneratorService.prototype.getName = function (pathHolderId) {
        return this._allMeasurePaths.flatMap(function (pathMap) {
            return pathHolderId.map(function (pathHolder) {
                return pathMap.get(pathHolder).name;
            });
        });
    };
    ConditionTextGeneratorService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.MessageService,
            idm_dataset_service_client_js_1.MeasurePathService,
            idm_session_data_provider_api_js_1.SessionDataProvider])
    ], ConditionTextGeneratorService);
    return ConditionTextGeneratorService;
}());
exports.ConditionTextGeneratorService = ConditionTextGeneratorService;
//# sourceMappingURL=condition-text-generator-service.js.map